export const initialAltimSetOptions = {
    column: 1,
    tearoff: true,
    background: true,
    bright: 80,
    font: 2,
    border: true,
    lines: 5,
};
//# sourceMappingURL=initialAltimSetOptions.js.map